var map = {
	"./awesome_ape_256.png": "2a70",
	"./custom_plan_256.png": "3c49",
	"./elegant_ermine_256.png": "7d9e",
	"./hot_bear_256.png": "8dc0",
	"./little_bunny_256.png": "ebaf",
	"./little_lemur_256.png": "da3d",
	"./power_panda_256.png": "4b46",
	"./roaring_rabbit_256.png": "ca4c",
	"./wild_wolf_256.png": "e650"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ad1";